/* eslint-disable sort-keys */
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'root',
  'title',
  'grid',
  'swatchItem',
  'oosOverlay',
]);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 * keys: ("root" | "title" | "grid" | "swatchItem" | "oosOverlay")[]
 * }>} SimpleCoverStepStyles
 */
const SimpleCoverStep = helpers.defineMultiStyleConfig({
  baseStyle: {
    root: {
      width: '100%',
      paddingY: 4,
    },
    title: {
      fontSize: {base: 'md', lg: 'lg'},
      fontWeight: 'semibold',
      marginBottom: 3,
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 3,
    },
    swatchItem: {
      position: 'relative',
      borderRadius: 'md',
      overflow: 'hidden',
      transition: 'all 0.2s',
      _hover: {
        transform: 'translateY(-2px)',
        boxShadow: 'md',
      },
    },
    oosOverlay: {
      position: 'absolute',
      inset: 0,
      backgroundColor: 'whiteAlpha.700',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      _after: {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '-5%',
        width: '110%',
        height: '1px',
        bg: 'gray.400',
        transform: 'rotate(-45deg)',
      },
    },
  },
});

export default SimpleCoverStep;
